import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {
 
  getProductInfo(query_data) {

    let data = {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      ...query_data
    }

    return Network.execute('GET', 'CWEBS0007A', data);      
  },
  getPriceInfo(query_data) {

    const pnocl = Store.getters['application/get_application_customer'].TNCLI;

    return Network.execute('GET', 'CWEBS0008A', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl,
      ...query_data
    });
    
  }, 
  getStockInfo(query_data) {

    return Network.execute('GET', 'CWEBS0009B', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      ...query_data
    });
  },
  getFicheTechnique(sCodeProduit) {

    return Network.execute('GET', 'CWEBS0024A', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pmod: sCodeProduit
    }, {}, {
      'Content-Type': 'application/json',
      'Accept': 'application/pdf'
    }, 'arraybuffer');
  },
  getImage(sNomImage) {

    return Network.execute('GET', 'get_image', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      sNomImage: sNomImage
    });
  },
  getFileProductImage(sRef, sImage) {

    return Network.execute(
      'GET',                     // method
      'get_file_product_image',  // webservice
      {
        piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
        sRef: sRef,
        sImage: sImage
      },
      undefined,   // payload
      {},          // headers
      'blob'       // responseType
    );
  }
}